import { ENDPOINT_ROUTES, BASE_URL } from "./routes";
import $ from "jquery";

const api = {
  fetchSettings: async () => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.settings;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  saveSetting: async ({ column, json }) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.settings + "/save";

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "POST",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ column, json }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  editSetting: async ({ column, json }) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.settings + "/edit";

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "PATCH",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ column, json }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  removeSetting: async (column) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.settings + "/remove";

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "DELETE",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ column }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
};

const settingsApi = { api };

export default settingsApi;

